import api from '../utilities/api';

export default {
    findMemberships(identifier, type, email) {
        return api.v2.get(`admin/membership-management/search?identifier=${identifier}&type=${type}&email=${email}`);
    },
    createMembership(membership) {
        return api.v2.post(`admin/membership-management/membership`, membership);
    },
    getMembership(membershipId) {
        return api.v2.get(`admin/membership-management/membership/${membershipId}`)
    },
    updateMembership(membershipId, membership) {
        return api.v2.put(`admin/membership-management/membership/${membershipId}`, membership);
    },
    importMembership(identifier, type, email) {
        return api.v2.post('admin/membership-management/import', {type: type, identifier: identifier, email: email});
    },
}
